export const MOBILE_BREAKPOINT = 900 // 900px is the mobile breakpoint
export const TABLET_BREAKPOINT = 1250
export const LARGE_SCREEN_BREAKPOINT = 1499
export const SETTINGS_ACTION_COLLAPSE_BREAKPOINT = 1100
